import { FaFacebookF, FaInstagram, FaPinterestP, FaTiktok, FaYoutube } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import logo from '../assets/logo.png';
import './Footer.css';

const shopLinks = [
  { label: 'All Products', href: '/products' },
  { label: 'Dog Supplements', href: '/collections/supplements' },
  { label: 'Pet Care', href: '/collections/pet-care' },
  { label: 'Toys & Accessories', href: '/collections/toys' },
  { label: 'Travel & Essentials', href: '/collections/essentials' },
];
const aboutLinks = [
  { label: 'Our Story', href: '/about' },
  { label: 'Why Trillium Paws™', href: '/about/why-trillium-paws' },
  { label: 'Blog & Resources', href: '/blog' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contact Us', href: '/contact' },
];
const careLinks = [
  { label: 'Track Order', href: '/track-order', external: true },
  { label: 'Shipping Policy', href: '/shipping-policy' },
  { label: 'Returns & Refunds', href: '/returns-refunds' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms of Service', href: '/terms-of-service' },
];

const socialLinks = [
  { name: 'Facebook', href: '#', icon: FaFacebookF },
  { name: 'Instagram', href: '#', icon: FaInstagram },
  { name: 'Pinterest', href: '#', icon: FaPinterestP },
  { name: 'YouTube', href: '#', icon: FaYoutube },
  { name: 'TikTok', href: '#', icon: FaTiktok },
];

function FooterLinkList({ links, labelledBy }) {
  return (
    <nav aria-labelledby={labelledBy}>
      <ul className="site-footer__links">
        {links.map(link => {
          const item = typeof link === 'string' ? { label: link } : link;
          return (
            <li key={item.label}>
              <a href={item.href}>
                {item.label}
                {item.external && <FiExternalLink aria-hidden="true" />}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="header-container site-footer__container">
        <div className="site-footer__columns">
          <div className="site-footer__brand">
            <a className="site-footer__logo-link" href="/" aria-label="Trillium Paws home">
              <img className="site-footer__logo" src={logo} alt="Trillium Paws" />
            </a>
            <p className="site-footer__tagline">Better Nutrition. Brighter Tomorrows.</p>
            <p className="site-footer__description">Providing our companions with the clean, vet-inspired nutritional integrity they deserve to thrive for a lifetime.</p>
          </div>

          <div className="site-footer__column">
            <h2 id="footer-shop">SHOP<span aria-hidden="true" /></h2>
            <FooterLinkList links={shopLinks} labelledBy="footer-shop" />
          </div>

          <div className="site-footer__column">
            <h2 id="footer-about">ABOUT<span aria-hidden="true" /></h2>
            <FooterLinkList links={aboutLinks} labelledBy="footer-about" />
          </div>

          <div className="site-footer__column site-footer__care">
            <h2 id="footer-care">CUSTOMER CARE</h2>
            <FooterLinkList links={careLinks} labelledBy="footer-care" />
            <h3>FOLLOW US</h3>
            <div className="site-footer__socials">
              {socialLinks.map(({ name, href, icon: Icon }) => (
                <a className="site-footer__social" href={href} aria-label={name} key={name}><Icon aria-hidden="true" /></a>
              ))}
            </div>
          </div>
        </div>

        <div className="site-footer__bottom">
          <p>© 2026 Trillium Paws. All rights reserved.</p>
          <p>Powered By <a href="#partners">American Web Partners</a></p>
        </div>
      </div>
    </footer>
  );
}